module.exports = __webpack_public_path__ + "img/img-ntiendas-quac.08064480.png";